import Home from './Home'

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/index.js